import { Spreadsheet } from '@syncfusion/ej2-spreadsheet';
import { Grid, Filter, Page, Sort, Edit, Toolbar, RecordClickEventArgs } from '@syncfusion/ej2-grids';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { CommonHelper } from '../../Helpers/CommonHelper';

export class ExcelFormatsManager {

    constructor(private containerElement: JQuery) { }

    private formatsGrid : Grid;
    private spreadsheet : Spreadsheet;

    private removeFormatModalHelper : ModalHelper;
    private viewExcelFormatModalHelper : ModalHelper;
    

    public initialize() {
        var self = this;

        Grid.Inject(Edit, Toolbar, Filter, Page, Sort);

        self.removeFormatModalHelper = new ModalHelper();
        self.removeFormatModalHelper.createModal("remove-excel-format-popup", true);        
        
        self.viewExcelFormatModalHelper = new ModalHelper();
        self.viewExcelFormatModalHelper.createModal("view-excel-format-popup", true);

        self.initializeFormatsTable();
    }

    private initializeFormatsTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var formatsContainer = self.containerElement.find('#excel-formats-table-container');
        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#ExcelFormatsGrid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;

        let data: DataManager = new DataManager({
            url: '/api/company/lookup/excel/formats',
            adaptor: new WebApiAdaptor
        });

        self.formatsGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
                columns: [
                    { field: 'Description', headerText: 'Description', autoFit: true, allowEditing: false},
                    { field: 'CustomerNameInSheet', headerText: 'Customer name in sheet',  autoFit: true, allowSorting: false},
                    { field: 'FormatUsageCount', headerText: 'Usages',  autoFit: true, width: 75},
                    { field: 'CreationDateTimeString', headerText: 'Created at', width: 150},
                    { field: 'CreatedBy', headerText: 'Created by', width: 150, allowSorting: false},
                    { field: 'LastModifiedTimeString', headerText: 'Modified at', width: 150},
                    { field: 'ExtraActions', headerText: '', width: 100, allowFiltering: false, autoFit: true, textAlign: 'Right', template: '${getExcelFormatExtraActions(data.Id, data.MostRecentDocHeaderGuid)}' }
                ],
                allowSorting: true,
                allowPaging: true,
                allowFiltering: false,
                allowSelection: false,
                enablePersistence: true,
                pageSettings: { pageSize: 100 },
                sortSettings:{
                    columns: [
                        { field: 'Description', direction: 'Ascending' }
                    ],
                },
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')

                    loadingContainer.addClass('d-none');
                    formatsContainer.removeClass('d-none');

                },
                recordClick: (args: RecordClickEventArgs) => {
                    if (args.target != undefined && args.rowData != undefined) {
                        var parsedTarget = $(args.target); 
                        if(parsedTarget.is('i')) {
                            parsedTarget = parsedTarget.parent();
                        }

                        var excelFormatId = args.rowData["Id"];
                        var mostRecentDocHeaderId = args.rowData["MostRecentDocHeaderGuid"];

                        if(parsedTarget.data('action') == 'remove-format' && excelFormatId != undefined) {
                            parsedTarget.prop('disabled', true);

                            self.removeFormatModalHelper.load(`?excelFormatId=${excelFormatId}&handler=RemoveExcelFormat`, () => {
                                parsedTarget.prop('disabled', false);
                                CommonHelper.bindDisablingSaveButton();
                            });
                        }                         
                        else if(parsedTarget.data('action') == 'view-format' && excelFormatId != undefined && mostRecentDocHeaderId != undefined) {
                            parsedTarget.prop('disabled', true);

                            self.viewExcelFormatModalHelper.load(`?excelFormatId=${excelFormatId}&handler=ViewExcelFormat`, undefined, () => {
                                parsedTarget.prop('disabled', false);
                                self.spreadsheet = new Spreadsheet( {
                                    showRibbon: false,
                                    showAggregate: false,
                                    showFormulaBar: false,
                                    allowEditing: false,
                                    openUrl: '/api/company/excel/open',
                                    created: (): void => {
                                        fetch(`/api/company/excel/${excelFormatId}/preview/${mostRecentDocHeaderId}`) // fetch the remote url
                                            .then((response) => {
                                                response.blob().then((fileBlob) => { // convert the excel file to blob
                                                    let file = new File([fileBlob], "Sample.xlsx");
                                                    self.spreadsheet.open({ file: file }); // open the file into Spreadsheet
                                                })
                                            })
                                    },
                                    openComplete: (args: any) => {
                                        if(args.response.data == 'NeedPassword' || args.response.data == 'InCorrectPassword') {
                                            //spreadsheetElement.removeClass('d-none');
                                        }
                                        else if(args.response.data == 'UnsupportedFile') {
                                            //spreadsheetElement.removeClass('d-none');
                                        }
                                        else {
                                            self.spreadsheet.selectRange('A1:A1');

                                            setTimeout(() => {
                                                self.spreadsheet.freezePanes(0, 0);  
                                            }, 250)

                                            setTimeout(() => {
                                                self.spreadsheet.unprotectSheet(self.spreadsheet.getActiveSheet().name);
                                                self.viewExcelFormatModalHelper.getModalContainer().find('div[data-column-and-row]').each((index, element) => {
                                                    var formatItem = $(element);

                                                    var cellRange = formatItem.data('column-and-row');
                                                    var excelFormatItemKey = formatItem.data('excel-format-item');
                                                    var formatItemType = formatItem.data('format-item-type');

                                                    var descriptionBackgroundColor = formatItem.find('span').css('background-color');
                                                    //descriptionBackgroundColor = ColorHelper.rgbToHex(descriptionBackgroundColor);

                                                    var columnAndRowInput = formatItem.find('input[data-column-and-row-input]');
                                                    var columnAndRowValueInput = formatItem.find('input[data-column-and-row-value-input]');
                                                    if(cellRange != undefined && cellRange.toString().length > 0) {
                                                        self.spreadsheet.getData(cellRange).then((cells)=> {
                                                            var index = 0;
                                        
                                                            cells.forEach((cell, key)=>{
                                                                if(index == 0) {
                                                                    self.spreadsheet.cellFormat({ backgroundColor: `${descriptionBackgroundColor}` }, cellRange);
                                                                        columnAndRowInput.val(cellRange);
                                        
                                                                        var cellValue = cell.value;
                                        
                                                                        cellValue = cellValue?.replace(/[\r\n]|[^\uD83C-\uDFFFa-zA-Z0-9\!\?\;\:\$\#\@\*\%\,\'\"\<\>\+\(\)\.\-\_]/g, ' ');
                                        
                                                                        if(cellValue != undefined) {
                                                                            columnAndRowValueInput.val(cellValue);
                                                                            columnAndRowValueInput.attr('title', cellValue);
                                                                        }
                                                                        else {
                                                                            columnAndRowValueInput.val('');
                                                                            columnAndRowValueInput.attr('title', '');
                                                                        }
                                                                }
                                        
                                                                index++;
                                                            })
                                                        });
                                                    }

                                                })                    
                                            }, 250)
                                        }
                                    },
                                });
                                self.spreadsheet.appendTo('#preview-excel-format-container');
                            }, 
                            undefined);
                        } 
                    }
                },
            });

        self.formatsGrid.appendTo('#ExcelFormatsGrid');



        (<any>window).initializeRemoveExcelFormat = () => {
            if(self.removeFormatModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.formatsGrid.refresh();
            }
        }
    }


    private selectCell(cellRange:string, formatItemKey:string, formatItemType: string, cellBackgroundColor: string) : boolean {
        var self = this;

        self.spreadsheet.unprotectSheet(self.spreadsheet.getActiveSheet().name);

        self.spreadsheet.getData(cellRange).then((cells) => {
            var index = 0;
            cells.forEach((cell, key)=>{
                if(index == 0) {
                    var inputGroupForKey = self.containerElement.find(`.input-group[data-excel-format-item="${formatItemKey}"]`);
                    inputGroupForKey.find('button[data-action="deselect-cell"]').prop('disabled', false);

                    var bgColor = cell.style?.backgroundColor;
                    self.spreadsheet.cellFormat({ backgroundColor: `${cellBackgroundColor}` }, cellRange);
                }

                index++;
            })
        })



        return true;
    }
    

}